// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5973) return "static/chunks/5973-be6ce404676abfd0.js";
	if (chunkId === 8294) return "static/chunks/8294-8677a42295f330a0.js";
	if (chunkId === 4217) return "static/chunks/4217-3a77fb058b1ed3c2.js";
	if (chunkId === 4470) return "static/chunks/4470-280f4618585857e8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"5028":"5493da1b","8626":"63b94182"}[chunkId] || chunkId) + "." + {"489":"48c8bb55a5bd79b6","2261":"b84e48931ce6623a","2643":"4e21c03795bbb745","4489":"2d114097a0d7af30","5028":"38bd86b3c4c3db88","6499":"df96450d3ec61829","7685":"fb04cf041be3eb2d","8421":"993a2f6cabfcd063","8626":"3c99fc6a8563d027","9638":"c349cca10d06c167"}[chunkId] + ".js";
};